import React, { useState, useEffect, useCallback } from "react"
import { Col } from "reactstrap" // Suponiendo que usas Reactstrap

const DebouncedInput = ({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) => {
  const [value, setValue] = useState(initialValue)

  // Actualizar el valor del input cuando el valor inicial cambie
  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  // Crear una función de onChange con debounce
  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value)
    }, debounce)

    return () => clearTimeout(timeout)
  }, [debounce, onChange, value])

  // Función para limpiar el input y el filtro
  const handleClear = useCallback(() => {
    setValue("")
    onChange("") // Esto también limpia el filtro en la tabla
  }, [onChange])

  return (
    <Col sm={4}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <input
          {...props}
          value={value}
          onChange={e => setValue(e.target.value)}
          //   style={{ flexGrow: 1 }}
        />
        {value && (
          <button
            onClick={handleClear}
            style={{
              position: "absolute",
              top: "-5px",
              right: "10px", // Mueve el botón al ángulo superior derecho
              background: "red",
              color: "white",
              border: "none",
              borderRadius: "50%",
              cursor: "pointer",
              fontSize: "0.8rem",
              width: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ✕
          </button>
        )}
      </div>
    </Col>
  )
}

export default DebouncedInput
